import { createStyles } from "@mantine/emotion";

export const useStylesUserTabContent = createStyles((theme) => {
  return {
    tabBox: {
      paddingTop: theme.spacing.userTabContent.padding.top,
      paddingBottom: theme.spacing.userTabContent.padding.bottom,
      h2: {
        fontFamily: theme.headings.fontFamily.secondary,
        paddingBottom: theme.spacing.userTabContent.heading.h2.paddingBottom,
        textAlign: "center",
        fontSize: theme.spacing.userTabContent.heading.h2.fontSize,
        fontWeight: "normal",
      },
      h3: {
        fontSize: theme.spacing.userTabContent.heading.h3.fontSize,
        fontFamily: theme.headings.fontFamily.secondary,
        paddingBottom: theme.spacing.userTabContent.heading.h3.paddingBottom,
        textAlign: "center",
      },
    },
  };
});
